<script setup lang="ts">
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import { useMicrosoftOAuthStore } from '@/@vxapp/MicrosoftOAuth/useMicrosoftOAuthStore'
import MicrosoftMailWorkspace from '@/views/setup/microsoft-oauth/MicrosoftMailWorkspace.vue'
import MicrosoftOAuthSettingsCard from '@/views/setup/microsoft-oauth/MicrosoftOAuthSettingsCard.vue'
import { AccessPageMeta } from '@/access/accessPageMeta'

const microsoftOAuthStore = useMicrosoftOAuthStore()

setPageTitle(PageMeta.MicrosoftOAuth.Settings.Title)
definePage({ meta: AccessPageMeta.MicrosoftOAuth.Settings.Meta })

onMounted(() => {
  setPageTitle(PageMeta.MicrosoftOAuth.Settings.Title)
})
</script>

<template>
  <VRow data-testid="microsoft-oauth-page">
    <VCol
      cols="12"
      data-testid="microsoft-oauth-settings-section"
    >
      <MicrosoftOAuthSettingsCard />
    </VCol>

    <VCol
      v-if="microsoftOAuthStore.status?.isLinked"
      cols="12"
      data-testid="microsoft-mail-workspace-section"
    >
      <MicrosoftMailWorkspace />
    </VCol>
  </VRow>
</template>
